module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEJJREFUeNpiYBgFBAAjiFAOmJUApBSobPaDuxvSFjACDTcAcs7TyAOGTEM+iEZT4WgyHU2mo8l0NJmOJlO6AIAAAwBYGyTHfS88YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-burger.png
// module id = bbCG
// module chunks = 0